import Input from '@/components/basicComponents/input';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Select from '@/components/basicComponents/select';
import { createSimpleSelectOption } from '@/components/basicComponents/select/utils';
import { useState } from 'react';
import styled from 'styled-components';

const reasonSelectOptions = [
  createSimpleSelectOption('', 'Select'),
  createSimpleSelectOption('Client preference'),
  createSimpleSelectOption('Manager rejection'),
  createSimpleSelectOption('Client unresponsive'),
  createSimpleSelectOption('Account closure')
];

interface TerminateProps {
  isOpen: boolean;
  id: string;
  updateAllocations: any;
  onClose: () => void;
}

export default function Terminate({ isOpen, id, updateAllocations, onClose }: TerminateProps) {
  const [select, setSelect] = useState('');
  const [note, setNote] = useState('');
  const onTerminate = () => {
    updateAllocations({
      variables: {
        data: [
          {
            id,
            operationsStatus: 'Terminated',
            allocationStatus: 'Terminated',
            terminationReason: select,
            terminationNote: note
          }
        ]
      }
    });
    onClose();
  };
  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title={'Terminate'}
      confirmButton={{ name: 'Terminate Proposal', onClick: onTerminate, disabled: !select }}
      showRequiredFields
    >
      <ContentWrapper>
        <Select label="Select Reason" value={select} setValue={(value) => setSelect(value)} options={reasonSelectOptions} size="md" isRequiredField />
        <Input placeholder="note" value={note} onChange={(e) => setNote(e.target.value)} size="md" />
      </ContentWrapper>
    </ModalWrappedContent>
  );
}

const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;
